import { NavLink, NavLinkProps, useLocation } from 'react-router-dom';
import { Route } from '../../constants';
import { useRouteVisibility } from '../../hooks/useRouteVisibility';

const NavOption = ({ children, active, ...props }: NavLinkProps & { active?: boolean }) => {
  return (
    <NavLink
      {...props}
      className={({ isActive }) =>
        `w-[100px] cursor-pointer rounded-[12px] border-2 border-transparent px-4 py-2 text-center text-base font-bold no-underline shadow-[0_0_0_2px_#ffffff00] ${
          isActive || active ? '!text-primary !border-primary !bg-white shadow-[0_0_0_2px_#ffffff99]' : 'text-white'
        }`
      }
    >
      {children}
    </NavLink>
  );
};

export const Nav = ({ onNavigate }: { onNavigate?: () => void }) => {
  const location = useLocation();
  const { isClinicsRouteVisible, isAdminRouteVisible, isInternalRouteVisible } = useRouteVisibility();

  return (
    <nav className="flex flex-col gap-4 md:flex-row">
      <NavOption
        to="/"
        state={{ resetView: true }}
        onClick={onNavigate}
        active={location.pathname === Route.Home || location.pathname === Route.Organization}
      >
        Home
      </NavOption>

      <NavOption to="/patients" state={{ resetView: true }} onClick={onNavigate}>
        Patients
      </NavOption>

      {isClinicsRouteVisible && (
        <NavOption to="/clinics" state={{ resetView: true }} onClick={onNavigate}>
          Clinics
        </NavOption>
      )}

      {isAdminRouteVisible && (
        <NavOption to="/admin" state={{ resetView: true }} onClick={onNavigate}>
          Admin
        </NavOption>
      )}

      {isInternalRouteVisible && (
        <NavOption to="/internal" state={{ resetView: true }} onClick={onNavigate}>
          Internal
        </NavOption>
      )}
    </nav>
  );
};
